import { render, staticRenderFns } from "./ContentFiles.vue?vue&type=template&id=e91887e2"
import script from "./ContentFiles.vue?vue&type=script&lang=js"
export * from "./ContentFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports